import { feedClient } from '../../lib/services';
import { PodcastFeedErrorCode } from '@wix/podcasts-feed-client';

const EPISODE_SELECTION = `{id,podcast{title,author,image},title,image,duration,date,enclosure{length,type,url},description,keywords}`;
const EPISODE_NAV_SELECTION = '{id,slug}';

function loadPodcastEpisode(variables: { url: string; id: string }) {
  return feedClient.getPodcastEpisode(variables, EPISODE_SELECTION);
}

function loadPodcastEpisodesWithNavFields(variable: { url: string }) {
  return feedClient.getPodcastEpisodes(variable, EPISODE_NAV_SELECTION);
}

function isEpisodeNotFoundError(error) {
  // NOTE: FEED_FORMAT_NOT_VALID was discussed as NOT_FOUND_ERROR
  // https://jira.wixpress.com/browse/POD-116
  return (
    error.errorCode === PodcastFeedErrorCode.FEED_FETCHING_FAILED ||
    error.errorCode === PodcastFeedErrorCode.FEED_FORMAT_NOT_VALID ||
    error.errorCode === PodcastFeedErrorCode.EPISODE_NOT_FOUND
  );
}

export {
  EPISODE_SELECTION,
  EPISODE_NAV_SELECTION,
  loadPodcastEpisode,
  loadPodcastEpisodesWithNavFields,
  isEpisodeNotFoundError,
};
